/**
 * Initials-placeholder headshot. Use this when no `headshot_key` is set on the
 * lawyer record; real photographs go through {@link LawyerHeadshot}, which
 * emits a `<picture>` against the /cdn/ derivatives produced by Phase 3's
 * ImageProcessor.
 *
 *   <Headshot initials="MS" size={96} />
 *   <Headshot initials="JR" size={48} hue={120} />
 */

export interface HeadshotProps {
    initials: string;
    size?: number;
    /** Hue shift 0-360; rotates the duotone background. Default 0. */
    hue?: number;
    radius?: number;
    className?: string;
}

export function Headshot({
    initials,
    size = 96,
    hue = 0,
    radius = 12,
    className,
}: HeadshotProps) {
    const trimmed = initials.trim().slice(0, 2).toUpperCase();
    const cls = [
        'inline-flex items-center justify-center select-none',
        'font-serif font-medium',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <span
            className={cls}
            role="img"
            aria-label={`${trimmed} headshot placeholder`}
            style={{
                width: size,
                height: size,
                borderRadius: radius,
                fontSize: size * 0.4,
                background: `linear-gradient(135deg, hsl(${hue}deg 45% 88%), hsl(${hue}deg 55% 32%))`,
                color: 'var(--color-paper)',
                lineHeight: 1,
            }}
        >
            {trimmed}
        </span>
    );
}

export default Headshot;
